<template>
  <v-container fluid fill-height>
    <v-card>
      <v-card-title>Sound Selection</v-card-title>
      <div id="settingsCardDiv" style="overflow-y: auto;">
        <v-dialog
          transition="dialog-top-transition"
          max-width="600"
          v-model="dialog"
        >
          <v-card>
            <v-toolbar
              color="primary"
              dark
            >Select sound for {{selectedPart.partN}}</v-toolbar>
            <v-card-text>
              <div style="height:10px"></div>
              <v-select
                :hint="`Selected: ${selectedSoundName}`"
                :items="$store.state.sounds"
                v-model="selectedSound"
                item-text="name"
                label="Select sound"
                persistent-hint
              ></v-select>
            </v-card-text>
            <v-card-actions class="justify-end">
              <v-btn
                text
                @click="closeSoundDialog(false)"
              >Close</v-btn>
              <v-btn
                text
                @click="closeSoundDialog(true)"
              >Save</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
        <div style="height:10px"></div>
        <v-btn text
          v-for="bodyPartSound in $store.state.bodyPartsSounds"
          :key="bodyPartSound.partN"
          @click="soundDialog(bodyPartSound)"
        >
          {{bodyPartSound.partN}}
        </v-btn>
        <div style="height:10px"></div>
      </div>
    </v-card>
  </v-container>
</template>

<script>
  export default {
    name: 'Settings',

    data: () => ({
      appHeightVar: 300,
      dialog: false,
      selectedSound: {},
      selectedPart: {},
      selectedSoundName: ""
    }),

    methods:{
      soundDialog(bodyPartSound){
        this.dialog = true
        this.selectedPart = bodyPartSound
        this.selectedSound = this.$store.getters.getRefSound(bodyPartSound.sound)
        this.selectedSoundName = this.selectedSound.name
      },

      closeSoundDialog(saving){
        this.dialog = false
        if(saving === true){
          this.selectedPart.sound = this.$store.getters.getSoundRef(this.selectedSound).ref
          this.$store.commit('setPartSound', this.selectedPart)
        }
        this.selectedSound = {}
        this.selectedPart = {}
      }
    },

    computed:{
      appHeight(){
        return this.$store.state.appHeight
      }
    },

    watch:{
      appHeight(newVal){
        this.appHeightVar = newVal
      },
      selectedSound(newVal){
        if(typeof newVal !== "object")
          this.selectedSoundName = newVal
      }
    },

    mounted: function(){
      this.$nextTick(()=>{
        document.getElementById("settingsCardDiv").style.maxHeight = this.appHeightVar
      })
    }
  }
</script>

<style>
.settingsCardDiv {
  -ms-overflow-style: none;  /* Internet Explorer 10+ */
  scrollbar-width: none;  /* Firefox */
}
.settingsCardDiv::-webkit-scrollbar { 
  display: none;  /* Safari and Chrome */
}
</style>